(function () {
  if (customElements.get('bm-options')) return;

  class BmOptions extends HTMLElement {
    connectedCallback() {
      this.rows = Array.from(this.querySelectorAll('[data-bmo-row]'));
      this.rows.forEach((row) => this.initRow(row));
    }

    initRow(row) {
      const carousel = row.querySelector('[data-bmo-carousel]');
      if (!carousel) return;

      const slides = Array.from(carousel.querySelectorAll('[data-bmo-slide]'));
      const dots = Array.from(row.querySelectorAll('[data-bmo-dot]'));
      const prev = row.querySelector('[data-bmo-prev]');
      const next = row.querySelector('[data-bmo-next]');
      const total = slides.length;
      if (total <= 1) return;

      let activeIdx = 0;

      const setActive = (idx) => {
        activeIdx = ((idx % total) + total) % total;
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIdx));
      };

      const scrollTo = (idx) => {
        const target = slides[idx];
        if (!target) return;
        carousel.scrollTo({
          left: target.offsetLeft - carousel.offsetLeft,
          behavior: 'smooth',
        });
      };

      const goTo = (idx) => {
        const wrapped = ((idx % total) + total) % total;
        setActive(wrapped);
        scrollTo(wrapped);
      };

      if (prev) prev.addEventListener('click', () => goTo(activeIdx - 1));
      if (next) next.addEventListener('click', () => goTo(activeIdx + 1));
      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => goTo(i));
      });

      const observer = new IntersectionObserver(
        (entries) => {
          let bestEntry = null;
          for (const entry of entries) {
            if (entry.isIntersecting) {
              if (!bestEntry || entry.intersectionRatio > bestEntry.intersectionRatio) {
                bestEntry = entry;
              }
            }
          }
          if (bestEntry) {
            const idx = slides.indexOf(bestEntry.target);
            if (idx >= 0 && idx !== activeIdx) setActive(idx);
          }
        },
        { root: carousel, threshold: 0.6 },
      );
      slides.forEach((slide) => observer.observe(slide));
    }
  }

  customElements.define('bm-options', BmOptions);
})();
